import React, { useEffect }                                          from 'react';
import { Button }                                                    from "semantic-ui-react";
import { useMutation }                                               from "@apollo/react-hooks";
import { runIfFunction }                                             from "@src/util";
import { Align, CorvalStaticProjectActivity, FuncOrAsyncFunc, Size } from "@src/types";
import { StyledContainer }                                           from "@src/views/containers";
import { StaticProjectActivityBulkUpdateShellFormContainerProps }          from "@src/views/pages/projects/activities/bulk/StaticProjectActivityBulkUpdateShell";


interface StaticProjectActivityBulkUpdateMenuizedFocusFormContainerProps extends StaticProjectActivityBulkUpdateShellFormContainerProps {
    onUpdateComplete: FuncOrAsyncFunc<[ mutatedActivitySet?: Array<CorvalStaticProjectActivity> ], void>,
    onUpdateError: FuncOrAsyncFunc<[ e: Error ], void>,
}

const StaticProjectActivityBulkUpdateMenuizedFocusFormContainerDefaultProps = {
    onUpdateComplete: null,
    onUpdateError:    null,
} satisfies Partial<StaticProjectActivityBulkUpdateMenuizedFocusFormContainerProps>

function StaticProjectActivityBulkUpdateMenuizedFocusFormContainer( { children, ...p }: StaticProjectActivityBulkUpdateMenuizedFocusFormContainerProps ){

    const props = { ...StaticProjectActivityBulkUpdateMenuizedFocusFormContainerDefaultProps, ...p } as StaticProjectActivityBulkUpdateMenuizedFocusFormContainerProps;

    const [ mutate, mutateReq ] = useMutation( props.mutation );

    useEffect( () => {

        if( mutateReq.data ){

            props.onComplete( mutateReq.data );

            runIfFunction( props.onUpdateComplete, mutateReq.data.updateProjectActivities );
        }

    }, [ mutateReq.data ] );

    const handleMutate = async () => {

        props.onSubmit();

        try{

            const args     = await props.graphArgs(),
                  response = await mutate( args );

            if( response.errors ){

                runIfFunction( props.onError, response.errors );
                runIfFunction( props.onUpdateError, response.errors );
            }

        } catch( e ) {

            runIfFunction( props.onError, e );
        }
    }

    return (
        <>
            { children }

            <StyledContainer textAlign={ Align.CENTER } margin={ [ Size.MD, null ] }>

                <Button primary
                        type={ 'button' }
                        content={ 'Update' }
                        disabled={ props.operationDisabled }
                        loading={ props.isLoading || props.isProcessing }
                        onClick={ handleMutate }/>

            </StyledContainer>
        </>
    );
}

const StaticProjectActivityBulkUpdateMenuizedFocusFormContainerMemo = React.memo( StaticProjectActivityBulkUpdateMenuizedFocusFormContainer );

export {
    StaticProjectActivityBulkUpdateMenuizedFocusFormContainerMemo as StaticProjectActivityBulkUpdateMenuizedFocusFormContainer,
    StaticProjectActivityBulkUpdateMenuizedFocusFormContainerDefaultProps,
    type StaticProjectActivityBulkUpdateMenuizedFocusFormContainerProps,
};
